import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const comparisons = [{
  bad: 'Antojo a las 3pm que arruina tu día',
  good: 'Snack listo en 5 min que te da energía real'
}, {
  bad: 'Comes chips o dulce y te sientes culpable',
  good: 'Comes rico, nutritivo y te sientes orgullosa'
}, {
  bad: 'Rompes tu dieta por un antojo',
  good: 'Tu plan sigue intacto semana tras semana'
}, {
  bad: 'Hambre de nuevo en 20 minutos',
  good: 'Saciedad real por 2 a 3 horas'
}, {
  bad: 'Culpa, frustración y promesas rotas',
  good: 'Control, satisfacción y consistencia real'
}, {
  bad: 'Gastar $8 en snacks procesados que no sacian',
  good: 'Snacks caseros por menos de $2 que sí funcionan'
}];
export function BeforeAfter() {
  return <section className="py-14 md:py-20 px-4 bg-brand-cream text-brand-darkText" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 space-y-6" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-brand-dark" data-id="element-4">
            Imagina Tu Próxima Semana
          </h2>
          <div className="max-w-2xl mx-auto text-lg text-brand-dark/80 space-y-4" data-id="element-5">
            <p data-id="element-6">Son las 3pm del lunes. El antojo llega — como siempre.</p>
            <p data-id="element-7">
              Pero esta vez, en vez de luchar contra él, abres tu guía.
              Identificas: "Es dulce. Es cortisol." Buscas en tu sección Dulce.
              Eliges el Bowl de Cacao con Plátano.
            </p>
            <p className="font-semibold text-brand-medium" data-id="element-8">
              5 minutos después tienes en tu mano algo rico, cremoso, que sabe a
              postre — y que está apagando tu cortisol con magnesio real.
            </p>
            <p data-id="element-9">El antojo desaparece. No en horas. En minutos.</p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-3xl overflow-hidden shadow-2xl border border-brand-light/20 mb-16" data-id="element-10">
          {/* BAD SIDE */}
          <div className="bg-red-50/50 p-8 md:p-12" data-id="element-11">
            <h3 className="text-2xl font-bold text-brand-red mb-8 flex items-center justify-center gap-2" data-id="element-12">
              <XCircle data-id="element-13" /> TU VIDA HOY
            </h3>
            <div className="space-y-6" data-id="element-14">
              {comparisons.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex gap-3 text-brand-dark/80" data-id="element-15">
                  <XCircle className="w-5 h-5 text-brand-red/50 flex-shrink-0 mt-0.5" data-id="element-16" />
                  <p data-id="element-17">{item.bad}</p>
                </motion.div>)}
            </div>
          </div>

          {/* GOOD SIDE */}
          <div className="bg-brand-medium/10 p-8 md:p-12 border-t md:border-t-0 md:border-l border-brand-medium/20" data-id="element-18">
            <h3 className="text-2xl font-bold text-brand-medium mb-8 flex items-center justify-center gap-2" data-id="element-19">
              <CheckCircle data-id="element-20" /> CON SNACK SIN ANTOJO
            </h3>
            <div className="space-y-6" data-id="element-21">
              {comparisons.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex gap-3 text-brand-dark font-medium" data-id="element-22">
                  <CheckCircle className="w-5 h-5 text-brand-medium flex-shrink-0 mt-0.5" data-id="element-23" />
                  <p data-id="element-24">{item.good}</p>
                </motion.div>)}
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-25">
          <CTAButton data-id="element-26">QUIERO APAGAR MI PRÓXIMO ANTOJO</CTAButton>
        </div>
      </div>
    </section>;
}